import React from 'react';
import styles from './LoaderDots.module.scss';

export const LoaderDots: React.FC = () => {
	return <div className={styles.loader}></div>;
};
